import { iframeResize } from '../iframe';

const toggleHandler = (event) => {
  const button = event.target;
  const buttonID = button.id;
  const content = document.querySelector(`[aria-labelledby="${buttonID}"]`);
  const isExpanded = content.getAttribute('aria-expanded');

  if (isExpanded === 'false') {
    content.setAttribute('aria-expanded', true);
    button.innerText = button.dataset.expandedText;
  } else {
    content.setAttribute('aria-expanded', false);
    button.innerText = button.dataset.collapsedText;
  }

  iframeResize('specsToggle');
};

const registerToggles = () => {
  const toggles = document.querySelectorAll('.toggle-button');
  toggles.forEach((toggle) => toggle.addEventListener('click', toggleHandler));
};

export {
  registerToggles,
};
